import { Injectable, OnInit } from '@angular/core';
import { ScenarioService } from './scenario.service';
import { ScenarioVersionService } from './scenario-version.service';
import * as dayjs from 'dayjs';

@Injectable({
  providedIn: 'root',
})
export class AutosaveService {
  autosaveInterval: any;
  scenario: any;
  saveCount = 0;
  scenarioChanged = true;

  constructor(
    private scenarioService: ScenarioService,
    private scenarioVersionService: ScenarioVersionService
  ) {
    this.scenarioService.data.subscribe((scenario) => {
      this.scenario = scenario;
    });

    this.scenarioService.saved.subscribe((saved) => {
      this.scenarioChanged = !saved;
    });
  }

  onStartAutosave() {
    // console.log('init autosave');
    if (this.autosaveInterval) {
      clearInterval(this.autosaveInterval);
    }
    this.autosaveInterval = setInterval(() => {
     //  console.log('autosave');
      this.saveCount++;

      if(!this.scenarioChanged){
     //   console.log('skipped autosave');
      }
      // check if it's changed.
      if (this.saveCount % 1 == 0 && this.scenarioChanged) {
        // console.log('autosaving');
        //console.log('autosave for ' + this.saveCount + ' for ' + this.scenario?.title);
        //this.scenarioService.setData(this.scenario);
        this.scenarioService
          .update(
            this.scenario.id,
            this.scenario.title,
            JSON.stringify(this.scenario)
          )
          .subscribe((responseData) => {
            //console.log('saved');
          });

        this.scenarioVersionService
          .create(
            this.scenario.id,
            'Autosave ' + dayjs().format(''),
            JSON.stringify(this.scenario),
            0,
            1
          )
          .subscribe((responseData) => {
            /*console.log(
              'autosave VERSION  for ' +
                this.saveCount +
                ' for ' +
                this.scenario?.title
            );*/
          });
      }
    }, 60000);
  }

  stop(){
    if (this.autosaveInterval) {
      clearInterval(this.autosaveInterval);
    }
  }
}
